import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainPage from "./Pages/MainPage";
import Policy from "./Pages/Policy";
import BlogsPage from "./Pages/BlogsPage";
import BlogDetailPage from "./Pages/BlogDetailPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/privacy-policy" element={<Policy />} />
        <Route path="/app-ads.txt" element={<Policy />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blog" element={<BlogsPage />} />
        <Route path="/blogs/:id" element={<BlogDetailPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
